module.exports = __webpack_public_path__ + "img/ball_2.90dde6e0.png";